'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId from "./app.api.-Drug-Requests-Accepted-List-Item$-Id.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29() {
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 as $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 };
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 as $h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 };
$h_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.apply__Lapp_api_DrugRequestsAcceptedListItem$Id__Z = (function(a) {
  return ((a instanceof $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dId.$c_Lapp_api_DrugRequestsAcceptedListItem$Id$OutOfStockMedicationReport) && (a !== null));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_api_DrugRequestsAcceptedListItem$Id__Z(v1);
});
$c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_api_DrugRequestsAcceptedListItem$Id__Z(v1);
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29, "app.api.DrugRequestsAcceptedListItem$Id$$anon$29", ({
  Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 as $d_Lapp_api_DrugRequestsAcceptedListItem$Id$$anon$29 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Id$$anon$29.js.map
